module.exports = __webpack_public_path__ + "static/blm-zoom-91bafb52c0234a9998eaa5793d6cf763.jpg";